import { Card, Row, Col } from 'react-bootstrap';
import React, { useState } from 'react';

import Level from './Level';
import Progress from './Progress';

export default function Pathway({ title, progress = null }) {

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  if (progress === null) {
    progress = getRandomNumber(1, 100);
  }



  return (
    <Row>
      <Col>
        <Card className="mb-3">
          <Card.Body>
            <Card.Title>
              <Row className="align-items-center">
                <Col xs={4} sm={3} md={3} lg={2} xl={2} xxl={1} style={{ border: '1px solid #00A261', borderRadius: '5px', padding: '10px' }}>
                  <p style={{ fontSize: '.8rem', marginBottom: '0' }}>
                    <i className="bi bi-play" style={{ fontSize: '1rem', color: '#00A261' }}></i> May-2021
                  </p>
                  <p style={{ fontSize: '.8rem', marginBottom: '0' }}>
                    {progress < 100 ? (
                      <>
                        <i className="bi bi-arrow-clockwise" style={{ fontSize: '1rem', color: '#00A261' }}></i> {progress}%
                      </>
                    ) : (
                      <>
                        <i className="bi bi-check2-circle" style={{ fontSize: '1rem', color: '#00A261' }}></i> July-2024
                      </>
                    )}
                  </p>
                </Col>
                <Col xs={7} lg={5} className="text-start" >
                  <h2>{title}</h2>
                  {progress < 100 ?
                    <p>Current progress: Level 3</p>
                    :
                    <p>Completed</p>}
                </Col>
                <Progress progress={progress} />
              </Row>
            </Card.Title>
            <Card.Text>
              This path is designed to help you build your skills as a humorous and engaging public speaker. The projects on this path focus on understanding your sense of humor and how that sense of humor translates to engaging audience members. The projects contribute to developing an understanding of how to effectively use humor in a speech, including challenging situations and impromptu speeches. This path culminates in an extended humorous speech that will allow you to apply what you learned.
            </Card.Text>

            <Row id='pathway-progress' style={{ display: isExpanded ? 'block' : 'none' }}>
              <Col xs={12}>
                <Level level="Level 1" title="Mastering Fundamentals" />
                <Level level="Level 2" title="Learning Your Style" />
                <Level level="Level 3" title="Increasing Knowledge" />
                <Level level="Level 4" title="Building Skills" />
                <Level level="Level 5" title="Demonstrating Expertise" />
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer
            className="text-muted text-center"
            style={{ borderTop: '1px solid #dee2e6', cursor: 'pointer' }}
            onClick={toggleExpand}
          >
            {isExpanded ?
              <i className="bi bi-chevron-compact-up" style={{ color: '#00A261' }}></i>
              :
              <i className="bi bi-chevron-compact-down" style={{ color: '#00A261' }}></i>
            }
          </Card.Footer>
        </Card>
      </Col>
    </Row >
  );
}